<template>
  <div class="wp-init">
    <slot v-bind="{ ...init, commit, put }" />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      init: {},
    };
  },
  mounted() {
    Object.entries(this.$attrs).forEach(([key, value]) => {
      this.$set(this.init, key, value);
    });
  },
  methods: {
    commit(key, value) {
      this.init[key] = value;
    },
    async put(key, value, url) {
      this.commit(key, value);
      try {
        const { data } = await axios.put(url, value);
        this.commit(key, data);
      } catch (e) {
        this.commit(key, Object.assign({}, {
          error: {
            status: e.response.status,
            statusText: e.response.statusText,
          },
        }, value));
      }
    },
  },
};
</script>
